<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'accountRecovery'"
    class="page"
  >
    <Header
      :setting="{
        title: '忘記密碼',
        hasCancelMethod: false,
      }"
    />

    <div class="page__form mv8">
      <input
        v-model.trim="form.twid"
        type="text"
        placeholder="身份證/Resident ID No."
        class="mb5"
      >
      <input
        v-model.trim="form.birthdate"
        type="text"
        placeholder="西元生日/Birth Date(YYYYMMDD)"
        class="mb5"
      >
    </div>
    <div
      @click="accountRecovery"
      class="label label--primary"
    >
      傳送密碼簡訊至手機
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @toLogin="toLogin"
  />
</template>

<script>
import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import composable from '@/composable/index';
import api from '@/api/index';
import spiderman from '@/spiderman/index';

export default {
  setup() {
    const page = ref('accountRecovery');
    const form = reactive({
      twid: '',
      birthdate: '',
    });
    const router = useRouter();

    async function accountRecovery() {
      try {
        spiderman.form.verify(form);
        form.birthdate = spiderman.moment(form.birthdate).format('YYYY-MM-DD');

        composable.loading.show('發送簡訊中，請稍候');

        const response = await api.member.accountRecovery(
          composable.member, form,
        );
        composable.modal.show({
          body: response.message,
          hasCloseButton: false,
          footer: [
            { content: '前往登入頁面', type: 'primary', onClickEmit: 'toLogin' },
          ],
        });
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function toLogin() {
      composable.modal.close();
      router.push({ path: '/member/login' });
    }

    return {
      page,
      composable,
      form,
      accountRecovery,
      toLogin,
    };
  },
};
</script>
